import { Box, Typography } from '@mui/material';

import type { Outcome } from '@/types';
import { resolveOutcomeData } from '@/utils/marketUtils';

interface OutcomeLegendListProps {
  outcomes: any[];
  getColor: (id: string, index: number) => string;
}

interface LegendItemProps {
  data: any;
  color: string;
}

function LegendItem({ data, color }: LegendItemProps) {
  let name = '';
  let price = 0;

  if (data.outcomes && Array.isArray(data.outcomes) && !data.price) {
    // It's a Market object
    const outcomesArray = data.outcomes as any[];
    const yesOutcome = outcomesArray.find((o) => o?.name === 'Yes') || outcomesArray[0];
    name = data.question || data.groupItemTitle || yesOutcome?.name || 'Unknown';
    price = Number(yesOutcome?.price || 0);
  } else {
    // It's an Outcome object
    name = data.name;
    price = Number(data.price || 0);
  }

  const percent = (price * 100).toFixed(1);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: color,
        }}
      />
      <Typography variant="body2" color="text.secondary">
        {name} {percent}%
      </Typography>
    </Box>
  );
}

export function OutcomeLegendList({ outcomes, getColor }: OutcomeLegendListProps) {
  return (
    <>
      {outcomes
        .filter((item) => !resolveOutcomeData(item).archived)
        .map((item, idx) => {
          let outcomeId = item.id;
          if (item.outcomes && Array.isArray(item.outcomes) && !item.price) {
            const yes = item.outcomes.find((o: any) => o.name === 'Yes');
            if (yes) outcomeId = yes.id;
          }

          const color = getColor(outcomeId || item.id, idx);

          return <LegendItem key={item.id} data={item} color={color} />;
        })}
    </>
  );
}

export default OutcomeLegendList;
